import { render, staticRenderFns } from "./PanelSwitcher.vue?vue&type=template&id=03810400&scoped=true"
import script from "./PanelSwitcher.vue?vue&type=script&lang=js"
export * from "./PanelSwitcher.vue?vue&type=script&lang=js"
import style0 from "./PanelSwitcher.vue?vue&type=style&index=0&id=03810400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03810400",
  null
  
)

export default component.exports